import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {ITOHistory, ITOHistoryWithId} from "../../types";
import {ReactComponent as ReturnArrow} from "../../assets/icons/returnArrow.svg";
import {ExchangesLinkObj, getExchangeSpotLink} from "../../constants";
import {useAppDispatch} from "../../redux/store";
import {
    setIsStoppedByToDetails, setIsToDetailsOpen, setSelectedItem, setSelectedPrecisions, setSelectedItemIndex,
    setCurrentHistoryState
} from "../../redux/actions";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {normalizeSide, normalizeTime, openInNewTab} from "../../utils";
import {CustomScrollLine, List, Market, Profit, Row, Time, Wrapper} from "./ScrollList.styled";
import {useLazyGetPrecisionsQuery} from "../../redux/rtkApi/toFlowApi";


export const ScrollList: React.FC<{
    // items: ITOHistoryWithId[],
    items: ITOHistory[],
    isHigh: boolean,
    isMobile: boolean,
    isDesktop: boolean,
    isWeb: boolean,
}> = ({
          items,
          isHigh,
          // highlightFrom,
          isMobile,
          isDesktop,
          isWeb,
      }) => {
    // const dispatch = useAppDispatch()
    // const listRef = useRef<HTMLDivElement>(null)
    // const [activeIndex, setActiveIndex] = useState(0)
    // const [isOpen, setIsOpen] = useState<boolean>(false)
    // const highlightFrom = useSelector(selectors.selectHighlightFrom)
    // const favorites = useSelector(selectors.selectFavorites)
    const isPlay = useSelector(selectors.selectIsPlay)
    const [triggerGetPrecision] = useLazyGetPrecisionsQuery()
    // const isFav = (market: string, first_ex: string, second_ex: string) => Boolean(favorites.find((item) => item.market === market && item.first_ex === first_ex && item.second_ex === second_ex))
    return (
        <List>
            {(items ?? []).map((to, index) => (
                <RowItem
                    // key={`${to.market}-${to.pure_profit}-${to.timestamp}-${to.first_ex}-${to.second_ex}`}
                    to={to}
                    index={index}
                    items={items}
                    // highlightFrom={highlightFrom}
                    triggerGetPrecision={triggerGetPrecision}
                    isFavorite={to.is_favorite}
                    // isFavorite={favorites.includes({market: to.market, first_ex: to.first_ex, second_ex: to.second_ex})}
                    isPlay={isPlay}
                />
            ))}
        </List>
    )
}

export default React.memo(ScrollList)


type RowProps = {
    to: ITOHistory
    index: number
    // highlightFrom?: number
    items: ITOHistory[]
    triggerGetPrecision: any
    isFavorite: boolean
    isPlay: boolean
}

const RowItem: React.FC<RowProps> = React.memo(
    ({ to, index
         // , highlightFrom
         , items, triggerGetPrecision, isFavorite, isPlay }) => {

        const dispatch = useAppDispatch()

        // const highlighted =
        //     highlightFrom ? to.pure_profit >= Number(highlightFrom) : undefined

        const handleClick = async () => {
            dispatch(setIsStoppedByToDetails(true))
            dispatch(setIsToDetailsOpen(true))
            dispatch(setSelectedItem(to))
            dispatch(setSelectedItemIndex(index))
            dispatch(setCurrentHistoryState(items))
            const res = await triggerGetPrecision({
                first_ex: to.first_ex,
                second_ex: to.second_ex,
                first_market: to.market,
                second_market: to.market
            })

            if (res.data) {
                dispatch(setSelectedPrecisions({
                    firstExPrice: res.data.first_precision.pricePrecision,
                    firstExVolume: res.data.first_precision.volumePrecision,
                    secondExPrice: res.data.second_precision.pricePrecision,
                    secondExVolume: res.data.second_precision.volumePrecision,
                    firstExVol24: res.data.first_precision.volume24,
                    firstExChange24: res.data.first_precision.change24,
                    secondExVol24: res.data.second_precision.volume24,
                    secondExChange24: res.data.second_precision.change24,
                }))
            }
        }

        const [timeFromAction, setTimeFromAction] = useState<string>('')
        // useEffect(() => {
        //     const interval = setInterval(() => {
        //         setTimeFromAction(normalizeTime(to.timestamp) ?? '')
        //     }, 1000)
        //
        //     return () => clearInterval(interval)
        // }, [])

        return (
            <Row
                $isHighlighted={to.is_highlighted}
                onClick={handleClick}
                isFavorite={isFavorite}
            >
                <Market>{to.market}</Market>

                <Profit>
                    {to.pure_profit >= 0 ? '+' : '-'} {to.pure_profit.toFixed(2)}$
                </Profit>

                <Time $isHighlighted={to.is_highlighted}>
                    {/*{isPlay ? timeFromAction : normalizeTime(to.timestamp)}*/}
                    {normalizeTime(to.timestamp)}
                </Time>
            </Row>
        )
    })
